module.exports = __webpack_public_path__ + "static/img/2.55b0ab6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/sp/2.png
// module id = WB1/
// module chunks = 0